import {
  DeviceAssignmentFilters,
  PatientNoteFilters,
  PrismaAppUsageFilter,
  QuestionnaireStatusFilter,
  SharingStatusFilters,
  TeleSettingsFilters,
} from '@shared/constants/filters';
import { PatientFilterCategory } from '@shared/constants/PatientFilterCategory';
import { SortDirections } from '@shared/constants/SortDirections';
import { PatientSortingFields } from '@shared/constants/sortingFields';
import { PatientsRootState } from '@shared/redux/state/patients';
import { PatientListTabIds } from '@shared/types/patientListTypes';

export const initPatientsRootState: PatientsRootState = {
  tabs: {
    activeTab: PatientListTabIds.SdbTelemonitoring,
  },
  searchQuery: '',
  sdbTelemonitoring: {
    sort: {
      field: PatientSortingFields.OverallRelevance,
      direction: SortDirections.Descending,
    },
    expandedPatientKey: null,
    scheduledPatientsExpanded: true,
  },
  ventilationTelemonitoring: {
    sort: {
      field: PatientSortingFields.OverallRelevance,
      direction: SortDirections.Descending,
    },
    expandedPatientKey: null,
    scheduledPatientsExpanded: true,
  },
  adminList: {
    scheduledPatientsExpanded: true,
    filters: {
      usersInCharge: [],
      deviceAssignmentFilter: DeviceAssignmentFilters.Empty,
      patientNoteFilter: PatientNoteFilters.Empty,
      teleSettingsFilter: TeleSettingsFilters.Empty,
      sharingStatusFilter: SharingStatusFilters.Empty,
      sharedByMeToTenant: '',
      sharedToMeFromTenant: '',
      medicalConditionId: null,
      patientCategory: PatientFilterCategory.All,
      prismaAppUsageFilter: PrismaAppUsageFilter.Empty,
      questionnaireStatus: QuestionnaireStatusFilter.All,
      questionnaireName: 'All',
    },
    searchQuery: '',
    sort: {
      field: PatientSortingFields.Name,
      direction: SortDirections.Ascending,
    },
  },
  filters: {
    usersInCharge: [],
    deviceAssignmentFilter: DeviceAssignmentFilters.Empty,
    patientNoteFilter: PatientNoteFilters.Empty,
    teleSettingsFilter: TeleSettingsFilters.Empty,
    sharingStatusFilter: SharingStatusFilters.Empty,
    sharedByMeToTenant: '',
    sharedToMeFromTenant: '',
    medicalConditionId: null,
    patientCategory: PatientFilterCategory.All,
    prismaAppUsageFilter: PrismaAppUsageFilter.Empty,
    questionnaireName: 'All',
    questionnaireStatus: QuestionnaireStatusFilter.All,
  },
};
